import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "filter-box filter-box--highlights highlights--full-page" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "highlights__header" }

import vWait from 'vue-wait/src/components/v-wait.vue'
import HighlightsByBook from '@/app/components/book/highlights/HighlightsByBook.vue'
import ExportHighlightsButton from '@/app/components/book/highlights/ExportHighlightsButton.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

import Layout from '@/app/components/Layout.vue' // @ is an alias to /src
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'

// Function for unit-testing purposes only (works only in unit-tests).
// Checking that unhandled errors are caught by Sentry.

export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightsAll',
  setup(__props) {

function _unitTestsThrowError4Sentry(): void {
  if ((window as any)['__UNIT_TESTING']) {
    throw new Error('Unhandled error should be caught by Sentry')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { class: "layout--topbar highlights-layout" }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, { title: "Highlights" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "highlights__title-box highlights__title-box--hide-mobile" }, [
                _createElementVNode("h1", {
                  class: "highlights__title",
                  onClick: _unitTestsThrowError4Sentry
                }, " Highlights, notes and bookmarks ")
              ]),
              _createVNode(ExportHighlightsButton)
            ])
          ])
        ]),
        _createVNode(vWait, { for: "Loading Books" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingSpinner)
          ]),
          _: 1
        }),
        _createVNode(HighlightsByBook)
      ])
    ]),
    _: 1
  }))
}
}

})